import {
    FETCH_DAILY_MOVE_IQ_EVENTS,
    FETCH_DAILY_MOVE_IQ_EVENTS_FETCHING,
    FETCH_DAILY_MOVE_IQ_EVENTS_SUCCESS,
    FETCH_DAILY_MOVE_IQ_EVENTS_FAIL,
    DELETE_MOVE_IQ_EVENT,
    DELETE_MOVE_IQ_EVENT_SUCCESS,
    DELETE_MOVE_IQ_EVENT_FAIL
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    moveIQEvents: {},
    moveIQEventsFetching: false,
    moveIQEventsFetchFail: false
};

// ======= Fetching Handlers =======
const fetchDailyMoveIQFetching = (state, action) => {
    return {
        moveIQEvents: {
            ...state.moveIQEvents
        },
        moveIQEventsFetching: true,
        moveIQEventsFetchFail: false
    };
};

const fetchDailyMoveIQSuccess = (state, action) => {
    return {
        moveIQEvents: {
            ...state.moveIQEvents,
            [action.displayName]: {
                ...state.moveIQEvents[action.displayName],
                [action.calendarDate]: action.moveIQEvents
            }
        },
        moveIQEventsFetching: false,
        moveIQEventsFetchFail: false
    };
};

const fetchDailyMoveIQFail = (state, action) => {
    return {
        moveIQEvents: {
            ...state.moveIQEvents
        },
        moveIQEventsFetching: false,
        moveIQEventsFetchFail: true
    };
};

// ======= Deleting Handlers =======
export function deleteMoveIQEventSuccess(state, action) {
    return {
        moveIQEvents: {
            ...state.moveIQEvents,
            [action.displayName]: {
                ...state.moveIQEvents[action.displayName],
                [action.calendarDate]: [
                    ...state.moveIQEvents[action.displayName][action.calendarDate].filter((event) => {
                        return (
                            event.startTimestampLocal !== action.event.startTimestampLocal ||
                            event.deviceId !== action.event.deviceId
                        );
                    })
                ]
            }
        }
    };
}

export function deleteMoveIQEventFail(state, action) {
    return {
        moveIQEvents: {
            ...state.moveIQEvents,
            [action.displayName]: {
                ...state.moveIQEvents[action.displayName]
            }
        }
    };
}

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DAILY_MOVE_IQ_EVENTS_FETCHING]: fetchDailyMoveIQFetching,
    [FETCH_DAILY_MOVE_IQ_EVENTS_SUCCESS]: fetchDailyMoveIQSuccess,
    [FETCH_DAILY_MOVE_IQ_EVENTS_FAIL]: fetchDailyMoveIQFail,
    [DELETE_MOVE_IQ_EVENT_SUCCESS]: deleteMoveIQEventSuccess,
    [DELETE_MOVE_IQ_EVENT_FAIL]: deleteMoveIQEventFail
};

// ======= Default Action =======
export default function moveIQEvents(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchDailyMoveIQEvents(displayName, calendarDate, evictCache) {
    return {
        type: FETCH_DAILY_MOVE_IQ_EVENTS,
        displayName: displayName,
        calendarDate: calendarDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function deleteMoveIQEvent(event, displayName, calendarDate) {
    return {
        type: DELETE_MOVE_IQ_EVENT,
        displayName: displayName,
        calendarDate: calendarDate,
        event: event
    };
}

// ======= Selectors =======
export const getDailyMoveIQEvents = (state, displayName, calendarDate) => {
    return state.moveIQEvents.moveIQEvents[displayName]
        ? state.moveIQEvents.moveIQEvents[displayName][calendarDate]
        : null;
};

export const isDailyMoveIQEventsFetching = (state) => {
    return state.moveIQEvents.moveIQEventsFetching;
};

export const didDailyMoveIQEventsFetchFail = (state) => {
    return state.moveIQEvents.moveIQEventsFetchFail;
};
